/* CorkProTech · JS global: cabecera, idioma, aparición al hacer scroll y cajón del carrito.
   La ficha (product.js) añade al carrito con window.CorkCart.add() y calcula precios con
   window.CorkCart.previewTotal(). */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const config = window.CorkTheme || {};
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Judge.me: los textos que pone el tema (snippets/judgeme-textos.liquid) entran en sus ajustes antes de que pinte.
     Este archivo va antes que sus scripts (todos diferidos), así que los leen ya cambiados. Sus {{ x }} vienen como [x]. */
  const jdgm = config.judgeme;
  if (jdgm && window.jdgmSettings) {
    Object.entries(jdgm.settings).forEach(([clave, texto]) => {
      window.jdgmSettings[clave] = texto.replace(/\[(number_of_reviews|average_rating|language|shop_name|email|max_length|max_media|file_name|media_type|size_limit)\]/g, '{{ $1 }}');
    });
  }

  /* Judge.me en la ficha: su cargador (loader.js, que pinta la lista de reseñas y el visor de fotos del carrusel) ya no
     arranca al abrir la página, sino al primer toque, scroll o tecla, o cuando las reseñas quedan a menos de pantalla y
     media (Fran, 16/10/2026). Este archivo va antes que el cargador (los dos diferidos): se le pone la marca con la que
     él mismo evita ejecutarse dos veces y, llegado el momento, se quita y se vuelve a pedir el mismo archivo. Mientras,
     las reseñas que trae el HTML y el carrusel (otro script) se ven igual. Si se llega con un enlace de Judge.me
     (escribir una reseña desde el correo, #judgeme…), carga como siempre. */
  const jdgmLoader = document.querySelector('script[src*="judgeme"][src$="/assets/loader.js"]');
  const jdgmEnlace = /#judgeme|judgeme_(token|review_uuid|dynamic_form|follow_up_token|upload_pictures|pre_verified)/.test(location.hash + location.search);
  if (jdgmLoader && document.getElementById('judgeme_product_reviews') && !jdgmEnlace && !window.jdgm?._loaderExecuted) {
    window.jdgm = window.jdgm || {};
    window.jdgm._loaderExecuted = true;
    const gestos = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
    let cerca;
    let pedido = false;
    const arranca = () => {
      if (pedido) return;
      pedido = true;
      gestos.forEach((tipo) => window.removeEventListener(tipo, arranca, true));
      cerca?.disconnect();
      window.jdgm._loaderExecuted = false;
      const script = document.createElement('script');
      script.src = jdgmLoader.src;
      document.head.appendChild(script);
    };
    gestos.forEach((tipo) => window.addEventListener(tipo, arranca, { capture: true, passive: true }));
    cerca = new IntersectionObserver((vistas) => { if (vistas.some((v) => v.isIntersecting)) arranca(); }, { rootMargin: '150% 0px' });
    document.querySelectorAll('.pdp-reviews, #judgeme_product_reviews').forEach((el) => cerca.observe(el));
  }

  /* Precio con el formato de dinero de la tienda (igual que el filtro money de Liquid). */
  const money = (cents) => {
    const value = (Number(cents) || 0) / 100;
    const split = (decimals, thousands, point) => {
      const [int, frac] = value.toFixed(decimals).split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? point + frac : '');
    };
    const formats = {
      amount: () => split(2, ',', '.'),
      amount_no_decimals: () => split(0, ',', '.'),
      amount_with_comma_separator: () => split(2, '.', ','),
      amount_no_decimals_with_comma_separator: () => split(0, '.', ',')
    };
    return (config.moneyFormat || '{{amount_with_comma_separator}} €').replace(
      /\{\{\s*(\w+)\s*\}\}/,
      (_, key) => (formats[key] || formats.amount)()
    );
  };
  window.CorkMoney = money;

  /* Menú de escritorio: desplegables que se abren con clic, teclado o puntero. */
  const dropdowns = [...document.querySelectorAll('[data-dropdown]')];
  const setDropdown = (item, open) => {
    item.toggleAttribute('data-open', open);
    item.querySelector('button').setAttribute('aria-expanded', String(open));
  };
  dropdowns.forEach((item) => {
    const button = item.querySelector('button');
    /* Si lo abrió el puntero, el clic lo deja abierto; solo un segundo clic lo cierra. */
    button.addEventListener('click', () => {
      const openedByHover = item.dataset.via === 'hover';
      item.dataset.via = 'click';
      setDropdown(item, openedByHover || !item.hasAttribute('data-open'));
    });
    if (window.matchMedia('(hover: hover)').matches) {
      item.addEventListener('pointerenter', () => {
        if (item.hasAttribute('data-open')) return;
        item.dataset.via = 'hover';
        setDropdown(item, true);
      });
      item.addEventListener('pointerleave', () => setDropdown(item, false));
    }
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) setDropdown(item, false);
    });
  });

  /* Menú de móvil */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.getElementById('MobileMenu');
  const setMenu = (open) => {
    if (!menuToggle || !mobileMenu) return;
    menuToggle.setAttribute('aria-expanded', String(open));
    mobileMenu.hidden = !open;
  };
  menuToggle?.addEventListener('click', () => setMenu(menuToggle.getAttribute('aria-expanded') !== 'true'));
  mobileMenu?.addEventListener('click', (event) => {
    if (event.target.closest('a')) setMenu(false);
  });

  /* Banner de cookies de Shopify en móvil: va en una línea (base.css); al tocar el texto se despliega o se recoge.
     Shopify lo pinta tarde, por eso se escucha en el documento. */
  document.addEventListener('click', (event) => {
    const body = event.target.closest('#shopify-pc__banner .shopify-pc__banner__body');
    if (body && !event.target.closest('a')) body.closest('#shopify-pc__banner').toggleAttribute('data-open');
  });

  /* Idioma: <details> que se cierra al pulsar fuera. */
  const langs = [...document.querySelectorAll('[data-lang]')];

  document.addEventListener('click', (event) => {
    langs.forEach((details) => {
      if (details.open && !details.contains(event.target)) details.open = false;
    });
    if (mobileMenu && !mobileMenu.hidden && !event.target.closest('.header-pill')) setMenu(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    dropdowns.forEach((item) => setDropdown(item, false));
    langs.forEach((details) => {
      if (details.open) {
        details.open = false;
        details.querySelector('summary').focus();
      }
    });
    if (menuToggle?.getAttribute('aria-expanded') === 'true') {
      setMenu(false);
      menuToggle.focus();
    }
  });

  /* Movimiento de entrada (docs/MOVIMIENTO.md). Cada .reveal ya empieza su entrada con el CSS al pintar.
     Aquí, lo que al arrancar queda entero por debajo de la pantalla pasa a esperar oculto y entra una
     sola vez al aparecer, escalonado dentro de su sección (cinco pasos como mucho). Lo que ya está a la
     vista, por encima o antes del ancla de la URL sigue con la entrada de la carga: nada se oculta
     después de pintarse. */
  const revealables = [...document.querySelectorAll('.reveal')].filter(
    (el) => !el.querySelector("form:not([action*='localization']), iframe, .shopify-app-block")
  );
  const show = (el, instant) => {
    el.classList.remove('is-waiting');
    el.classList.add('is-visible');
    if (instant) el.classList.add('is-instant');
  };
  if ('IntersectionObserver' in window && !reduceMotion.matches) {
    const sectionOf = (el) => el.closest('.shopify-section') || el;
    const upTo = (el, target) => {
      const section = sectionOf(target);
      return section.contains(el) || Boolean(el.compareDocumentPosition(section) & Node.DOCUMENT_POSITION_FOLLOWING);
    };
    /* En un carrusel horizontal (tarjetas en móvil), lo que queda fuera de la pista no cruzaría nunca la
       pantalla: se vigila la pista y entra todo junto. */
    const tracks = new Map();
    const trackOf = (el) => {
      for (let node = el.parentElement; node && !node.matches('.shopify-section, main'); node = node.parentElement) {
        if (/auto|scroll/.test(getComputedStyle(node).overflowX)) return node;
      }
      return null;
    };
    const observer = new IntersectionObserver(
      (entries) => {
        const bySection = new Map();
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          const section = sectionOf(entry.target);
          const group = (tracks.get(entry.target) || [entry.target]).filter((el) => el.classList.contains('is-waiting'));
          bySection.set(section, [...(bySection.get(section) || []), ...group]);
        });
        bySection.forEach((group) =>
          group.forEach((el, i) => {
            el.style.setProperty('--delay', `calc(var(--rise-step) * ${Math.min(i, 4)})`);
            show(el);
          })
        );
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
    const hashTarget = () =>
      window.location.hash.length > 1 && document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
    const arrival = hashTarget();
    revealables.forEach((el) => {
      if (el.getBoundingClientRect().top < window.innerHeight || (arrival && upTo(el, arrival))) {
        show(el);
      } else {
        el.classList.add('is-waiting');
        const track = trackOf(el);
        if (!track) {
          observer.observe(el);
        } else {
          if (!tracks.has(track)) {
            tracks.set(track, []);
            observer.observe(track);
          }
          tracks.get(track).push(el);
        }
      }
    });
    const showNow = (test) =>
      revealables.forEach((el) => {
        if (!el.classList.contains('is-waiting') || !test(el)) return;
        observer.unobserve(el);
        show(el, true);
      });
    /* Saltos dentro de la página (barra fija, estrellas, enlace de saltar al contenido): la sección de
       destino y las de encima se ven ya, sin entrada, y el salto cae en su sitio. */
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href*="#"]');
      if (!link || link.pathname !== window.location.pathname || link.hash.length < 2) return;
      const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
      if (target) showNow((el) => upTo(el, target));
    });
    window.addEventListener('hashchange', () => {
      const target = hashTarget();
      if (target) showNow((el) => upTo(el, target));
    });
    /* Con el teclado, lo que recibe el foco se ve aunque el navegador lo deje en el borde de la pantalla. */
    document.addEventListener('focusin', (event) => {
      const waiting = event.target.closest && event.target.closest('.reveal.is-waiting');
      if (waiting) showNow((el) => el === waiting);
    });
    /* Al recargar a media página, el navegador devuelve el scroll después: lo que queda por encima, ya. */
    window.addEventListener('load', () =>
      window.requestAnimationFrame(() => showNow((el) => el.getBoundingClientRect().bottom < 0))
    );
  } else {
    revealables.forEach((el) => show(el));
  }
  /* Pasada la carga, las entradas de la carga no se repiten si un bloque se vuelve a mostrar o a pintar. */
  window.addEventListener('load', () =>
    window.setTimeout(() => document.documentElement.classList.add('motion-settled'), 1500)
  );

  /* Al saltar a un ancla, al llegar a la página con ella (#judgeme_product_reviews desde la página de la
     reseña con foto) o dentro de la página (las estrellas del título, la barra fija), lo que carga
     después por encima (fotos, carrusel de Judge.me) mueve el destino. Durante unos segundos se recoloca
     cada vez que la página cambia de alto, salvo que el cliente ya se haya movido. */
  const keepHashInPlace = () => {
    const target = window.location.hash.length > 1 && document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
    if (!target || !('ResizeObserver' in window)) return;
    const userEvents = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
    const realign = () => target.scrollIntoView({ block: 'start' });
    /* Judge.me, al cambiar el ancla a su widget, lo desliza con su propio margen (30 px, bajo la
       cabecera). Al terminar ese desplazamiento se vuelve a colocar; solo si el descuadre es pequeño, para
       no deshacer un scroll del cliente con la barra. */
    const afterScroll = () => {
      const gap = Math.abs(target.getBoundingClientRect().top - parseFloat(getComputedStyle(target).scrollMarginTop || 0));
      if (gap > 2 && gap < 160) realign();
    };
    const keepInPlace = new ResizeObserver(realign);
    const stop = () => {
      keepInPlace.disconnect();
      window.removeEventListener('scrollend', afterScroll);
      userEvents.forEach((type) => window.removeEventListener(type, stop));
    };
    keepInPlace.observe(document.body);
    window.addEventListener('scrollend', afterScroll);
    userEvents.forEach((type) => window.addEventListener(type, stop, { passive: true }));
    window.setTimeout(stop, 6000);
  };
  keepHashInPlace();
  window.addEventListener('hashchange', keepHashInPlace);

  /* Judge.me nombra las flechas de su carrusel en inglés («Previous slide», «Next slide») en cualquier idioma: el
     lector de pantalla las lee con los textos del tema, en el idioma de la página. Cuál es cuál sale de lo que
     traía Judge.me (su onclick y su etiqueta), guardado antes de cambiarla. Judge.me las pinta tarde. */
  document.querySelectorAll('[data-arrow-labels]').forEach((seccion) => {
    const [anterior, siguiente] = seccion.dataset.arrowLabels.split('|');
    const nombra = () => seccion.querySelectorAll('.jdgm-arrow').forEach((flecha) => {
      if (!flecha.dataset.origen) flecha.dataset.origen = `${flecha.getAttribute('onclick') || ''} ${flecha.getAttribute('aria-label') || ''}`;
      const texto = /prev/i.test(flecha.dataset.origen) ? anterior : siguiente;
      if (flecha.getAttribute('aria-label') !== texto) flecha.setAttribute('aria-label', texto);
    });
    nombra();
    new MutationObserver(nombra).observe(seccion, { childList: true, subtree: true });
  });

  /* El resto de lo que Judge.me deja fijo en inglés en su código, igual en todos los idiomas y sin ajuste en la app:
     las etiquetas de los lectores de pantalla y la del campo de YouTube. Se cambian por las del idioma de la página
     en el widget y en el formulario y el visor de fotos, que Judge.me cuelga del body y pinta tarde. */
  if (jdgm) {
    const e = jdgm.labels;
    const fijas = new Map(Object.entries({
      'Customer reviews carousel': e.carousel, Tabs: e.tabs, 'Sort reviews by': e.sort_by, 'Verified checkmark': e.verified,
      'View review image': e.view_image, 'Play review video': e.play_video, 'Review Image': e.image,
      'Close review form': e.close_form, 'Review form pages': e.form_pages, Rating: e.rating, 'Privacy and Terms': e.privacy_terms,
      'Review form navigation': e.form_navigation, 'Previous step': e.previous_step, 'Next step': e.next_step,
      'Remove file': e.remove_file, 'YouTube URL': e.youtube_url, 'Review Media Gallery': e.media_gallery,
      'Scroll thumbnails left': e.thumbnails_back, 'Scroll thumbnails right': e.thumbnails_forward, 'More media': e.more_media,
      'Loading thumbnail': e.loading_thumbnail, Previous: e.previous, Next: e.next, Close: e.close, 'Close modal': e.close
    }));
    const estrellas = (n) => e.stars_of_5.replace('[n]', n);
    const traduce = (texto) => {
      if (fijas.has(texto)) return fijas.get(texto);
      let m = texto.match(/^(?:Review by (.+?)|Review), ([\d.]+) out of 5 stars(, .+?)?\. Open review\.$/);
      if (m) return `${m[1] ? e.review_by.replace('[name]', m[1]) : e.review}, ${estrellas(m[2])}${m[3] || ''}. ${e.open_review}.`;
      if ((m = texto.match(/^([\d.]+) out of 5 stars$/))) return estrellas(m[1]);
      if ((m = texto.match(/^(\d+) stars?$/))) return m[1] === '1' ? e.one_star : e.n_stars.replace('[n]', m[1]);
      return null;
    };
    const repasa = () => document.querySelectorAll('.pdp-reviews, .jdgm-write-review-modal, .jdgm-modal').forEach((raiz) => {
      raiz.querySelectorAll('[aria-label], [title], img[alt], label').forEach((el) => {
        ['aria-label', 'title', 'alt'].forEach((atributo) => {
          const texto = el.getAttribute(atributo);
          const nuevo = texto && traduce(texto);
          if (nuevo && nuevo !== texto) el.setAttribute(atributo, nuevo);
        });
        if (el.tagName === 'LABEL' && !el.childElementCount) {
          const nuevo = traduce(el.textContent.trim());
          if (nuevo && nuevo !== el.textContent) el.textContent = nuevo;
        }
      });
    });
    let pendiente = false;
    new MutationObserver(() => {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(() => { pendiente = false; repasa(); });
    }).observe(document.body, { childList: true, subtree: true });
    repasa();
  }

  /* Con el teclado o no: el Tabulador marca la página y el ratón o el dedo la desmarcan. Lo usa el CSS para el foco de
     lo que no es nuestro y no sabe de :focus-visible desde fuera (el botón de Shop Pay, product.css). */
  document.addEventListener('keydown', (event) => { if (event.key === 'Tab') document.documentElement.dataset.teclado = ''; });
  document.addEventListener('pointerdown', () => { delete document.documentElement.dataset.teclado; });

  /* Vídeos decorativos: en silencio y solo mientras se ven; con movimiento reducido, con controles. */
  const autoplayVideos = document.querySelectorAll('video[data-autoplay]');
  /* Con el ahorro de datos puesto, los de fondo no arrancan (se quedan en su fotograma). Solo eso: el tipo de red que
     estima Chrome (3g con datos móviles a menudo) dejaba quietos en Android los de Nosotros (Fran, 09/10/2026), y con
     el HLS el vídeo ya empieza con la calidad que da la red. */
  const ahorro = Boolean(navigator.connection?.saveData);
  if (ahorro) autoplayVideos.forEach((video) => { if (video.hasAttribute('data-decorative')) video.removeAttribute('data-autoplay'); });
  if (reduceMotion.matches || !('IntersectionObserver' in window)) {
    /* Los de fondo (data-decorative) se quedan quietos en el primer fotograma, sin controles. */
    autoplayVideos.forEach((video) => { if (!video.hasAttribute('data-decorative')) video.controls = true; });
  } else {
    const videoObserver = new IntersectionObserver(
      /* Al salir de la vista se para y se suelta del todo: sin sus fuentes, load() deja libre el reproductor (con ellas,
         Android lo volvía a preparar y seguía bajando el vídeo, aun con preload="none", y el siguiente no arrancaba con
         datos). Debajo queda su fotograma. Al volver a verse recupera sus fuentes y empieza otra vez, casi siempre desde
         la caché. Primero sueltan los que salen y luego arrancan los que entran: al bajar de golpe llegan juntos. */
      (entries) => {
        entries.filter((entry) => !entry.isIntersecting).forEach(({ target: video }) => {
          if (video.paused && video.readyState === 0) return;
          video.pause();
          video.fuentes ||= [...video.querySelectorAll('source')];
          video.fuentes.forEach((fuente) => fuente.remove());
          video.load();
        });
        entries.filter((entry) => entry.isIntersecting).forEach(({ target: video }) => {
          if (video.fuentes && !video.querySelector('source')) {
            video.append(...video.fuentes);
            video.load();
          }
          video.play().catch(() => {});
        });
      },
      { threshold: 0.25 }
    );
    /* Los que se ven al abrir (el del hero), cuando ya está su fotograma (la imagen del hero es el LCP): así no le
       quitan red a lo primero que se pinta. Sin fotograma, tras cargar la página. Los de más abajo, desde ya: solo
       arrancan al verse. Esperar a la carga de la página los dejaba parados en el móvil, donde llega a los 5-15 s. */
    const videos = [...document.querySelectorAll('video[data-autoplay]')];
    videos.forEach((video) => {
      if (video.getBoundingClientRect().top >= window.innerHeight) return videoObserver.observe(video);
      const fotograma = video.parentElement.querySelector('img');
      if (fotograma) return fotograma.decode().catch(() => {}).then(() => videoObserver.observe(video));
      if (document.readyState === 'complete') videoObserver.observe(video);
      else window.addEventListener('load', () => videoObserver.observe(video), { once: true });
    });
  }

  /* Vídeos de clientes dentro de la página en vez de mandar a Instagram (cork-ugc-inline.js del tema
     actual). Si un reel no está en el mapa, la tarjeta sigue llevando a Instagram. */
  const UGC_CDN = 'https://cdn.shopify.com/videos/c/vp/';
  const UGC_VIDEOS = {
    Dc0xDUItKZz: '71a9ecc1d90b4c4cbcb4dde03794bc5a/71a9ecc1d90b4c4cbcb4dde03794bc5a.HD-720p-1.6Mbps-95904128.mp4',
    DdCCOKgtOMw: 'c5a8c9d88ea24ddeb0774aa6e56f2738/c5a8c9d88ea24ddeb0774aa6e56f2738.HD-720p-1.6Mbps-95904129.mp4',
    DcEAqLDMLMD: 'c1bc8b3f8e4b4f6da21643ace1992666/c1bc8b3f8e4b4f6da21643ace1992666.HD-720p-1.6Mbps-95904114.mp4',
    DbirOerto4p: 'e21ccdb9144e4d63a818d8d4228b716d/e21ccdb9144e4d63a818d8d4228b716d.HD-720p-1.6Mbps-95904115.mp4',
    DanQ9t6FbAb: 'c8f6f0c59a974873b17abc0d09715c98/c8f6f0c59a974873b17abc0d09715c98.HD-720p-1.6Mbps-95904116.mp4',
    DYFAvQXNtn8: '2b131a4463214dc094c7a01a4b592b09/2b131a4463214dc094c7a01a4b592b09.HD-720p-1.6Mbps-95904119.mp4',
    DZ71ScaKzIN: 'ff4cc0011a7d4eb09f3b1099e3cf32c6/ff4cc0011a7d4eb09f3b1099e3cf32c6.HD-720p-1.6Mbps-95904121.mp4',
    DbFeEyutS4D: '242ba0a3748b48a78030d15daff08a3f/242ba0a3748b48a78030d15daff08a3f.HD-720p-1.6Mbps-95904125.mp4'
  };
  const UGC_SUB = {
    es: 'Toca un vídeo para verlo.',
    ca: 'Toca un vídeo per veure’l.',
    en: 'Tap a video to watch it.',
    fr: 'Touche une vidéo pour la regarder.',
    de: 'Tippe auf ein Video, um es anzusehen.',
    it: 'Tocca un video per guardarlo.',
    pt: 'Toca num vídeo para o ver.'
  };
  document.querySelectorAll('[data-ugc]').forEach((list) => {
    let inline = false;
    list.querySelectorAll('[data-ugc-tile]').forEach((tile) => {
      /* Vídeo propio (ugc.liquid, «Vídeo propio»): sus fuentes van en un <template>; los de clientes, por el mapa. */
      const sources = tile.querySelector('[data-ugc-sources]');
      const id = (tile.getAttribute('href').match(/instagram\.com\/(?:p|reel)\/([^/?#]+)/i) || [])[1];
      const src = id && UGC_VIDEOS[id];
      if (!src && !sources) return;
      inline = true;
      tile.removeAttribute('target');
      const play = (muted) => {
        const box = document.createElement('div');
        box.className = tile.className;
        const video = document.createElement('video');
        if (sources) video.append(sources.content.cloneNode(true));
        else video.src = UGC_CDN + src;
        video.controls = true;
        video.playsInline = true;
        video.muted = muted;
        video.poster = tile.querySelector('img')?.currentSrc || '';
        video.addEventListener('play', () => list.querySelectorAll('video').forEach((other) => other !== video && other.pause()));
        box.append(video);
        tile.replaceWith(box);
        video.play().catch(() => {});
      };
      tile.addEventListener('click', (event) => {
        event.preventDefault();
        play(false);
      });
      /* «Arranca al verse»: sin sonido (el navegador no deja otra cosa sin un toque) y con controles para dárselo. */
      if (tile.hasAttribute('data-ugc-autoplay') && 'IntersectionObserver' in window && !reduceMotion.matches) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting) || !tile.isConnected) return;
          observer.disconnect();
          play(true);
        }, { threshold: 0.5 });
        observer.observe(tile);
      }
    });
    const sub = list.closest('section')?.querySelector('[data-ugc-sub]');
    const text = UGC_SUB[(document.documentElement.lang || 'es').slice(0, 2)];
    if (inline && sub && text) sub.textContent = text;
  });

  /* Carrito: el cajón o, en /cart (allí no se pinta el cajón), la página. Los dos pintan el mismo
     contenido (snippets/cart-contents.liquid) y los atienden las mismas funciones. */
  const drawer = document.querySelector('[data-cart-drawer]');
  const host = drawer || document.querySelector('[data-cart-page]');
  const sectionId = drawer ? 'cart-drawer' : host?.dataset.section;
  const contentSelector = drawer ? '[data-cart-drawer-content]' : '[data-cart-page]';

  const panel = () => (drawer ? drawer.querySelector(contentSelector) : host);

  const updateCount = () => {
    const count = Number(panel()?.dataset.count || 0);
    document.querySelectorAll('[data-cart-count]').forEach((badge) => {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
  };

  const showError = (message) => {
    const box = host?.querySelector('[data-cart-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = !message;
  };

  const openDrawer = () => {
    if (!drawer) {
      window.location.href = `${root}cart`;
      return;
    }
    if (drawer.open) return;
    renderOffer();
    drawer.showModal();
    requestAnimationFrame(() => drawer.classList.add('is-open'));
  };

  const closeDrawer = () => {
    if (!drawer?.open) return;
    drawer.classList.remove('is-open');
    const finish = () => drawer.open && drawer.close();
    if (reduceMotion.matches) return finish();
    panel()?.addEventListener('transitionend', finish, { once: true });
    setTimeout(finish, 400);
  };

  /* Precio con descuento: Shopify lo calcula en un carrito aparte creado con la Storefront API (sin
     token). No toca el carrito del cliente ni pasa por /cart/add, así que no cuenta como «añadido al
     carrito» (product_added_to_cart, add_to_cart de GA4 y Meta). ids: variantes, una por funda; da el
     total en céntimos con los descuentos automáticos por línea. Caché por combinación; un fallo (429,
     red) no se guarda y el siguiente intento vuelve a preguntar.
     ponytail: versión 2026-07 de la API fija (Shopify la mantiene un año: renovarla antes de julio de
     2027) y céntimos de moneda con 2 decimales (EUR). */
  const priceCache = new Map();
  const PREVIEW_QUERY = `mutation CorkPreview($lines: [CartLineInput!]!, $country: CountryCode) @inContext(country: $country) {
    cartCreate(input: { lines: $lines }) {
      cart { lines(first: 20) { nodes { cost { totalAmount { amount } } } } }
      userErrors { message }
    }
  }`;

  const previewTotal = (ids) => {
    const key = ids.join(':');
    if (priceCache.has(key)) return priceCache.get(key);
    const counts = ids.reduce((acc, id) => acc.set(id, (acc.get(id) || 0) + 1), new Map());
    const lines = [...counts].map(([id, quantity]) => ({ merchandiseId: `gid://shopify/ProductVariant/${id}`, quantity }));
    const request = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 5500);
      try {
        const response = await fetch('/api/2026-07/graphql.json', {
          method: 'POST',
          credentials: 'omit',
          signal: controller.signal,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ query: PREVIEW_QUERY, variables: { lines, country: window.Shopify?.country } })
        });
        if (!response.ok) throw new Error('preview');
        const data = await response.json();
        const result = data.data?.cartCreate;
        if (data.errors || !result?.cart || result.userErrors.length) throw new Error('preview');
        const total = result.cart.lines.nodes.reduce((sum, line) => sum + Math.round(Number(line.cost.totalAmount.amount) * 100), 0);
        if (!(total > 0)) throw new Error('preview');
        return total;
      } finally {
        clearTimeout(timeout);
      }
    })();
    priceCache.set(key, request);
    request.catch(() => priceCache.delete(key));
    return request;
  };

  /* Oferta de 2ª unidad en el cajón. Abrir el cajón no calcula nada: el total de las dos (de
     previewTotal) sale cuando el cliente cambia el modelo o el diseño de la 2ª, con 300 ms de espera
     entre cambios; si esa combinación ya estaba calculada, sale al momento. Sin cálculo (pendiente,
     error o 429) no hay total: nunca uno sin descuento que contradiga la oferta. */
  let offerRequest = 0;
  let offerTimer;

  const offerVariant = (box) => {
    const data = JSON.parse(box.querySelector('[data-offer-json]').textContent);
    const chosen = [...box.querySelectorAll('[data-offer-option]')].reduce((acc, select) => {
      acc[Number(select.dataset.offerOption)] = select.value;
      return acc;
    }, {});
    return { data, variant: data.variants.find((v) => Object.entries(chosen).every(([i, value]) => v.o[Number(i)] === value)) };
  };

  /* Diseño de la 2ª: solo los que existen para el modelo elegido y, si ese modelo solo tiene Classic, sin
     «y el diseño de regalo». La misma regla que la ficha (renderDesigns y buildUnit de product.js). */
  const syncOfferDesigns = (box) => {
    const select = box.querySelector('[data-offer-design]');
    if (!select) return;
    const { variants, designs } = JSON.parse(box.querySelector('[data-offer-json]').textContent);
    const d = Number(select.dataset.offerOption);
    const others = [...box.querySelectorAll('[data-offer-option]')].filter((s) => s !== select);
    const sameModel = variants.filter((v) => others.every((s) => v.o[Number(s.dataset.offerOption)] === s.value));
    const values = designs.filter((value) => sameModel.some((v) => v.o[d] === value));
    if (values.join('|') !== [...select.options].map((o) => o.value).join('|')) {
      const current = select.value;
      select.replaceChildren(...values.map((value) => new Option(value, value)));
      select.value = values.includes(current) ? current : values[0];
    }
    const free = box.querySelector('[data-offer-design-free]');
    if (free) free.hidden = sameModel.every((v) => v.o[d].toLowerCase() === 'classic');
  };

  const renderOffer = async (compute = false) => {
    const box = host?.querySelector('[data-cart-offer]');
    if (!box) return;
    syncOfferDesigns(box);
    const request = ++offerRequest;
    const { data, variant } = offerVariant(box);
    const q = (selector) => box.querySelector(selector);
    const button = q('[data-offer-add]');
    const row = q('.offer__total');
    if (!variant || !variant.a) {
      q('[data-offer-price]').textContent = data.unavailable;
      q('[data-offer-was]').textContent = '';
      q('[data-offer-save]').textContent = '';
      row.hidden = false;
      button.disabled = true;
      return;
    }
    button.disabled = false;
    button.dataset.variant = variant.id;
    row.hidden = true;
    const ids = [Number(box.dataset.first), variant.id];
    if (!compute && !priceCache.has(ids.join(':'))) return;
    try {
      const total = await previewTotal(ids);
      if (request !== offerRequest) return;
      const was = Number(box.dataset.firstPrice) + variant.p;
      const save = was - total;
      q('[data-offer-price]').textContent = money(total);
      q('[data-offer-was]').textContent = save > 0 ? money(was) : '';
      q('[data-offer-save]').textContent = save > 0 ? data.save.replace('{{ amount }}', money(save)) : '';
      row.hidden = false;
    } catch (error) {
      /* Sin total: el descuento lo aplica Shopify igual al añadir. */
    }
  };

  /* Foco tras sustituir el contenido: vuelve al mismo control (data-focus, o el mismo color del
     complemento) o, si ya no está (línea quitada, oferta añadida), al primero del carrito, sin mover el
     scroll. lastControl cubre Safari, que no da el foco a botones y casillas al pulsarlos. */
  let lastControl = null;
  const focusKey = (el) => {
    if (el?.dataset?.focus) return `[data-focus="${CSS.escape(el.dataset.focus)}"]`;
    if (el?.type === 'radio' && el.name) return `[name="${CSS.escape(el.name)}"][value="${CSS.escape(el.value)}"]`;
    return '';
  };

  /* Sustituye el contenido del carrito por el que devuelve la API (parámetro sections) y anuncia el
     total nuevo al lector de pantalla. */
  const render = (sections) => {
    const html = sections && sections[sectionId];
    if (!html || !host) return;
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector(contentSelector);
    const current = panel();
    if (!next || !current) return;
    const key = focusKey(current.contains(document.activeElement) ? document.activeElement : lastControl);
    lastControl = null;
    current.innerHTML = next.innerHTML;
    current.dataset.count = next.dataset.count;
    updateCount();
    renderOffer();
    const status = document.querySelector('[data-cart-status]');
    if (status) status.textContent = current.querySelector('[data-cart-total]')?.dataset.cartTotal || current.querySelector('.cart-empty p')?.textContent.trim() || '';
    if (key && (!drawer || drawer.open)) {
      const target = current.querySelector(key) || current.querySelector('[data-focus]') || current.querySelector('a[href], button');
      target?.focus({ preventScroll: true });
    }
  };

  const request = async (path, body) => {
    const response = await fetch(`${root}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: sectionId })
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || config.cartError);
    return data;
  };

  const busy = (state) => {
    const body = host?.querySelector('[data-cart-body]');
    if (body) body.setAttribute('aria-busy', String(state));
  };

  const change = async (line, quantity) => {
    busy(true);
    showError('');
    try {
      const data = await request('cart/change.js', { line, quantity });
      render(data.sections);
    } catch (error) {
      showError(error.message);
    } finally {
      busy(false);
    }
  };

  window.CorkCart = {
    money,
    previewTotal,
    open: openDrawer,
    close: closeDrawer,
    /* items: [{ id, quantity, properties }]. Lanza error si Shopify no lo añade. */
    async add(items) {
      const data = await request('cart/add.js', { items });
      render(data.sections);
      openDrawer();
      return data;
    }
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-cart-open]');
    if (opener && drawer) {
      event.preventDefault();
      openDrawer();
    }
  });

  if (drawer) {
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer || event.target.closest('[data-cart-close]')) closeDrawer();
    });

    drawer.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDrawer();
    });
  }

  if (host) {
    if (!drawer) renderOffer();

    host.addEventListener(
      'click',
      (event) => {
        const control = event.target.closest('[data-focus], input[type="radio"]');
        if (control) lastControl = control;
      },
      true
    );

    /* Cantidad (con 1 unidad, el «−» quita la línea). */
    host.addEventListener('click', (event) => {
      const step = event.target.closest('[data-line][data-qty]');
      if (step && !step.disabled) change(Number(step.dataset.line), Number(step.dataset.qty));
    });

    host.addEventListener('change', (event) => {
      if (!event.target.matches('[data-offer-option]')) return;
      renderOffer();
      clearTimeout(offerTimer);
      offerTimer = setTimeout(() => renderOffer(true), 300);
    });

    host.addEventListener('click', async (event) => {
      const add = event.target.closest('[data-offer-add]');
      if (!add || add.disabled) return;
      add.disabled = true;
      busy(true);
      showError('');
      try {
        render((await request('cart/add.js', { items: [{ id: Number(add.dataset.variant), quantity: 1 }] })).sections);
      } catch (error) {
        showError(error.message);
        add.disabled = false;
      } finally {
        busy(false);
      }
    });

    /* Complemento (el cordón) en el carrito: marcarlo lo añade como línea aparte (cantidad 1),
       desmarcarlo lo quita y cambiar de color con él puesto lo cambia en el carrito. */
    host.addEventListener('change', async (event) => {
      const card = event.target.closest('[data-addon-context="cart"]');
      if (!card) return;
      const module = card.closest('[data-cart-addon]');
      const line = Number(module.dataset.line) || 0;
      const check = card.querySelector('[data-addon-check]');
      const picked = card.querySelector('[data-addon-variant]:checked') || card.querySelector('[data-addon-variant]');
      const variant = picked ? Number(picked.value) : Number(JSON.parse(card.querySelector('[data-addon-json]').textContent)[0].id);
      let action;
      if (event.target.matches('[data-addon-variant]')) {
        action = line
          ? request('cart/update.js', { updates: { [module.dataset.variant]: 0, [variant]: 1 } })
          : request('cart/add.js', { items: [{ id: variant, quantity: 1 }] });
      } else if (event.target === check) {
        action = check.checked ? request('cart/add.js', { items: [{ id: variant, quantity: 1 }] }) : request('cart/change.js', { line, quantity: 0 });
      }
      if (!action) return;
      busy(true);
      showError('');
      try {
        const data = await action;
        if (data.sections) render(data.sections);
        else render((await request('cart/update.js', {})).sections);
      } catch (error) {
        showError(error.message);
      } finally {
        busy(false);
      }
    });

    let noteTimer;
    host.addEventListener('input', (event) => {
      if (!event.target.matches('[data-cart-note]')) return;
      clearTimeout(noteTimer);
      const note = event.target.value;
      noteTimer = setTimeout(() => {
        fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note })
        }).catch(() => {});
      }, 500);
    });
  }
  /* Flechas de una pista con scroll horizontal ([data-track-nav] = id de la pista): cada flecha avanza lo que
     se ve de la pista, tarjeta a tarjeta con su scroll-snap; en un extremo, la de ese lado se apaga. Si todo
     cabe, no salen. Con movimiento reducido, el salto es directo. */
  document.querySelectorAll('[data-track-nav]').forEach((nav) => {
    const track = document.getElementById(nav.dataset.trackNav);
    const prev = nav.querySelector('[data-track-prev]');
    const next = nav.querySelector('[data-track-next]');
    if (!track || !prev || !next) return;
    const step = () => {
      const item = track.firstElementChild;
      if (!item) return track.clientWidth;
      const size = item.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
      return Math.max(1, Math.floor(track.clientWidth / size)) * size;
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      nav.hidden = max <= 1;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
    };
    const go = (dir) => track.scrollBy({ left: dir * step(), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
    let frame;
    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
